import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
const CdnIcon = ({ icon, className }) => {
    const { CdnIcon: theme } = useTheme('Shared');
    return (React.createElement("svg", { className: cn(theme.root, className), "data-icon": icon },
        React.createElement("use", { xlinkHref: `#${icon}` })));
};
export default CdnIcon;
